import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
    API_COUNTRY_CODE_DIRECTIONS_MASTER_AVAILABLE_COUNTRIES,
    API_COUNTRY_CODE_DIRECTIONS_MASTER_CREATE,
    API_COUNTRY_CODE_DIRECTIONS_MASTER_UPDATE,
    API_COUNTRY_CODE_DIRECTIONS_MASTER_SINGLE,
} from "../../../service/url";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import { ROUTES } from "../../../utilities/constant";

const CountryCodeDirectionForm = ({ isEdit = false }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [countryCodes, setCountryCodes] = useState([]);
    const [countryCodeId, setCountryCodeId] = useState(null);
    const [isEnabled, setIsEnabled] = useState(true);
    const [busy, setBusy] = useState(false);
    const [currentCountry, setCurrentCountry] = useState(null);

    useEffect(() => {
        const url = isEdit && id
            ? `${API_COUNTRY_CODE_DIRECTIONS_MASTER_AVAILABLE_COUNTRIES}?excludeId=${id}`
            : API_COUNTRY_CODE_DIRECTIONS_MASTER_AVAILABLE_COUNTRIES;

        getApiCall(url, {})
            .then((data) => setCountryCodes(Array.isArray(data) ? data : []))
            .catch(() => setCountryCodes([]));

        if (isEdit && id) {
            getApiCall(API_COUNTRY_CODE_DIRECTIONS_MASTER_SINGLE(id), {})
                .then((resp) => {
                    setCountryCodeId(resp?.country_code_id);
                    setIsEnabled(resp?.is_enabled !== false);
                    if (resp?.country_code) setCurrentCountry(resp.country_code);
                })
                .catch((err) => toast.error(typeof err === "string" ? err : JSON.stringify(err)));
        }
    }, [id, isEdit]);

    const countryOptions = countryCodes.map((c) => ({
        value: c.id,
        label: `${c.name} ${c.calling_code ? `+${c.calling_code}` : ""}`,
    }));

    if (isEdit && currentCountry && !countryOptions.some((o) => o.value === currentCountry.id)) {
        countryOptions.unshift({
            value: currentCountry.id,
            label: `${currentCountry.name} ${currentCountry.calling_code ? `+${currentCountry.calling_code}` : ""}`,
        });
    }

    const submit = () => {
        if (!countryCodeId) {
            toast.error("Select country");
            return;
        }

        setBusy(true);
        const payload = { country_code_id: Number(countryCodeId), is_enabled: !!isEnabled };
        const url = isEdit
            ? API_COUNTRY_CODE_DIRECTIONS_MASTER_UPDATE(id)
            : API_COUNTRY_CODE_DIRECTIONS_MASTER_CREATE;

        postApiCall(url, payload)
            .then(() => {
                toast.success(isEdit ? "Updated" : "Created");
                navigate(`/${ROUTES.COUNTRY_CODE_DIRECTIONS.LIST}`);
            })
            .catch((err) => {
                toast.error(typeof err === "string" ? err : JSON.stringify(err));
                setBusy(false);
            });
    };

    return (
        <Row>
            <Col xl="12">
                <Card>
                    <Card.Header>
                        <h4 className="card-title">
                            {isEdit ? "Edit" : "Add"} Country Code
                        </h4>
                    </Card.Header>
                    <Card.Body>
                        <Form>
                            <Row>
                                <Form.Group className="col-md-6 form-group">
                                    <Form.Label>
                                        Country <span style={{ color: "red" }}>*</span>
                                    </Form.Label>
                                    <Select
                                        className="theme-react-select"
                                        classNamePrefix="theme-react-select"
                                        options={countryOptions}
                                        value={countryOptions.find((o) => o.value === countryCodeId) || null}
                                        onChange={(opt) => setCountryCodeId(opt?.value || null)}
                                        placeholder="Select country"
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-6 form-group d-flex align-items-center">
                                    <Form.Check
                                        type="switch"
                                        id="cc-enabled-switch"
                                        label={isEnabled ? "Enabled" : "Disabled"}
                                        checked={isEnabled}
                                        onChange={(e) => setIsEnabled(e.target.checked)}
                                    />
                                </Form.Group>
                            </Row>
                            <div className="d-flex gap-2">
                                <Button onClick={submit} disabled={busy}>
                                    {isEdit ? "Update" : "Create"}
                                </Button>
                                <Button
                                    variant="secondary"
                                    onClick={() => navigate(`/${ROUTES.COUNTRY_CODE_DIRECTIONS.LIST}`)}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default CountryCodeDirectionForm;
